import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=2f94b61e&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=2f94b61e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f94b61e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f94b61e')) {
      api.createRecord('2f94b61e', component.options)
    } else {
      api.reload('2f94b61e', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=2f94b61e&scoped=true", function () {
      api.rerender('2f94b61e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/sharing_agreement/direct_investment_event/viewExcuteRecord/detail.vue"
export default component.exports